import { ArrowUpRight } from "lucide-react";

const HERO_IMG = "/frostico-machine.png";

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-16 md:pb-24">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        {/* Overline */}
        <div className="flex items-center gap-3 text-[11px] font-mono-accent text-[#5AB0FF] mb-8">
          <span className="h-px w-10 bg-[#5AB0FF]" />
          <span data-testid="hero-overline">
            Launching · Dorset & Hampshire · September 2026
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          {/* Left: Type */}
          <div className="lg:col-span-7 relative z-10">
            <h1
              data-testid="hero-headline"
              className="font-display font-bold text-[54px] leading-[0.9] md:text-[92px] lg:text-[112px] tracking-tighter"
            >
              Dorset & Hampshire’s <span className="text-[#8B5CF6]">first</span> self-serve
              <br />
              Mr Whippy
              <br />
              <span className="italic font-medium text-white/80">
                vending machine.
              </span>
            </h1>

            <p
              data-testid="hero-sub"
              className="mt-8 max-w-xl text-white/70 text-lg leading-relaxed"
            >
              Frostico serves creamy cups of soft-serve, 24/7. Host one at your location and
              earn a <span className="text-white font-semibold">15% profit share</span>{" "}
              — or hire it for weddings, birthdays and corporate events across
              Dorset and Hampshire, UK.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="#partner"
                data-testid="hero-cta-partner"
                className="group inline-flex items-center justify-between gap-4 rounded-full bg-[#8B5CF6] px-6 py-4 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 neon-glow-pink"
              >
                Host a machine · earn 15%
                <ArrowUpRight
                  size={18}
                  className="transition-transform duration-200 group-hover:rotate-45"
                />
              </a>
              <a
                href="#book"
                data-testid="hero-cta-book"
                className="group inline-flex items-center justify-between gap-4 rounded-full border border-[#5AB0FF]/60 bg-transparent px-6 py-4 text-sm font-semibold text-[#5AB0FF] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#5AB0FF]/10"
              >
                Book for your event
                <ArrowUpRight
                  size={18}
                  className="transition-transform duration-200 group-hover:rotate-45"
                />
              </a>
            </div>

            {/* Stats */}
            <div className="mt-14 grid grid-cols-3 gap-6 max-w-2xl">
              {[
                { k: "15%", v: "Profit share for hosts" },
                { k: "24/7", v: "Self-serve. Always on." },
                { k: "1st", v: "In Dorset & Hampshire" },
              ].map((s) => (
                <div key={s.k} className="border-l border-white/15 pl-4">
                  <div className="font-display text-3xl md:text-4xl font-bold tracking-tight">
                    {s.k}
                  </div>
                  <div className="mt-2 font-mono-accent text-[10px] text-white/60">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Image */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 bg-white neon-glow-pink">
              <img
                src={HERO_IMG}
                alt="Frostico self-serve ice cream vending machine"
                className="absolute inset-0 h-full w-full object-contain"
              />
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#0A0B10] via-[#0A0B10]/40 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div>
                  <div className="font-mono-accent text-[10px] text-[#5AB0FF]">
                    Model 01
                  </div>
                  <div className="font-display text-2xl font-bold text-white">
                    Frostico
                  </div>
                </div>
                <div className="rounded-full border border-white/30 bg-black/50 backdrop-blur-md px-3 py-1 text-[10px] font-mono-accent text-white">
                  IN PRODUCTION
                </div>
              </div>
            </div>
            <div className="absolute -top-6 -right-6 rounded-2xl bg-[#5AB0FF] text-[#0A0B10] px-4 py-3 rotate-3 shadow-lg neon-glow-cyan">
              <div className="font-mono-accent text-[10px]">Profit share</div>
              <div className="font-display text-2xl font-bold leading-none">
                15%
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
